export function formatCurrency(
    amount: number | string | undefined | null,

    options: Intl.NumberFormatOptions = {},
) {
    if (amount === null || amount === undefined) return undefined;
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        ...options,
    }).format(Number(amount));
}
